import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Film, FolderOpen, MessageSquare, Eye, TrendingUp } from 'lucide-react';

const Dashboard = () => {
  const { api } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/admin/dashboard').then(r => setData(r.data)).catch(console.error);
  }, []);

  if (!data) return <div className="admin-section"><p className="loading-text">Loading...</p></div>;

  const stats = [
    { label: 'Total Videos', value: (data?.total_videos || 0), icon: Film, color: '#06b6d4' },
    { label: 'Categories', value: (data?.total_categories || 0), icon: FolderOpen, color: '#8b5cf6' },
    { label: 'Comments', value: (data?.total_comments || 0), icon: MessageSquare, color: '#ec4899' },
    { label: 'Total Views', value: (data?.total_views || 0).toLocaleString(), icon: Eye, color: '#10b981' },
  ];

  return (
    <div className="admin-section">
      <h2 className="section-title"><TrendingUp size={20} /> Dashboard</h2>
      <div className="stats-grid">
        {stats.map((s, i) => (
          <div key={i} className="stat-card" style={{ borderTopColor: s.color }}>
            <div className="stat-icon" style={{ color: s.color }}><s.icon size={24} /></div>
            <div className="stat-value">{s.value}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
      <div className="dashboard-grid">
        <div className="admin-card">
          <h3 className="card-subtitle">Recent Videos</h3>
          {(data?.recent_videos || []).length === 0 ? <p className="empty-text">No videos yet</p> :
            (data?.recent_videos || []).map(v => (
              <div key={v.id} className="list-item">
                <span className="list-title">{v.title}</span>
                <span className="list-meta">{v.views} views</span>
              </div>
            ))
          }
        </div>
        <div className="admin-card">
          <h3 className="card-subtitle">Recent Comments</h3>
          {(data?.recent_comments || []).length === 0 ? <p className="empty-text">No comments yet</p> :
            (data?.recent_comments || []).map(c => (
              <div key={c.id} className="list-item">
                <span className="list-title"><strong>{c.user}:</strong> {c.text}</span>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
